function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAreaSearchFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.996 9.571c.191 0 .385.03.578.087l6.78 2.057a1.979 1.979 0 001.277-.043L14.5 11c.188.609.5 1 1 1.5l-2.16 1.042c-.111.042-.227.063-.34.094v13.96l5.628-2.137c.12-.047.248-.07.372-.104V14.583c.5.417 1.5.417 2 .417v10.331c.104.027.209.043.31.077l5.696 1.92V18.83C27.5 18.5 28.5 17.5 29 17.007v10.298a2.015 2.015 0 01-1.997 2.024c-.209 0-.423-.034-.636-.105l-5.695-1.92a1.984 1.984 0 00-1.335.024l-6.706 2.543a1.977 1.977 0 01-1.277.044L3.426 27.51A2.02 2.02 0 012 25.572V11.595c0-1.15.931-2.024 1.996-2.024zM4 25.572l7 2.143V13.68c-.075-.018-.152-.028-.227-.051l-6.779-2.057.006 14z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 12c-1.93 0-3.5-1.57-3.5-3.5S18.57 5 20.5 5 24 6.57 24 8.5 22.43 12 20.5 12zM26 8.5a5.5 5.5 0 10-11 0 5.5 5.5 0 008.552 4.575L27.477 17 29 15.477l-3.925-3.925A5.474 5.474 0 0026 8.5z",
    fill: props.color
  }));
}

export default SvgIconAreaSearchFilled;